/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Nav_AiInputs */

const da_admin_nav_ai = /** @type {(inputs: Admin_Nav_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI og økonomi`)
};

/** @type {(inputs: Admin_Nav_AiInputs) => LocalizedString} */
const en_admin_nav_ai = da_admin_nav_ai;

/**

* @param {Admin_Nav_AiInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const admin_nav_ai = /** @type {((inputs?: Admin_Nav_AiInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Nav_AiInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_nav_ai(inputs)
	return /** @type {LocalizedString} */ ("AI og økonomi")
});